export default {
  OK: "ตกลง",
  CLOSE: "บัญชีถูกปิด!",
  BLOCK: "บัญชีถูกบล็อก!",
  FREEZE: "บัญชีถูกอายัด",
  SUSPEND: "บัญชีของคุณเปลี่ยนเป็นดูได้เท่านั้น",
  passwordRequired: "ต้องการรหัสผ่าน!",
  usernameRequired: "ต้องมีชื่อผู้ใช้!",
  incompletedRequest: "เกิดข้อผิดพลาดบางอย่าง ...",

  session_not_exists: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  session_expired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  invalidSession: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  accountIdRequired: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ...",
  NoUserAccessRight: "เซสชันหมดอายุแล้ว! กรุณาเข้าสู่ระบบอีกครั้งเพื่อดำเนินการต่อ ...",
  account_not_exists: "รหัสผ่านไม่ถูกต้อง.",
  invalid_password: "รหัสผ่านไม่ถูกต้อง.",
  secondary_account_exists: "ชื่อเล่นของคุณถูกสร้างไว้แล้ว",
  systemError: "ข้อผิดพลาดระบบภายใน",
  new_login_id_exists: "ชื่อเล่นไม่ถูกต้องโปรดลองตั้งชื่อเล่นอื่น",
  loginLimit: "คุณเข้าสู่ระบบบ่อยเกินไปโปรดลองอีกครั้งหลังจาก 1 นาที ...",
  requestLimit: "คุณมีคำขอบ่อยเกินไป",
  unableToGetBalanceAtTheMoment: "ข้อผิดพลาดเซิร์ฟเวอร์ภายใน",
  oddsDisplayInvalid: "อัตราเดิมพันกำลังอัปเดต...",
  oddsIsUpdating: "อัตราเดิมพันกำลังอัปเดต...",
  atLeastTwoMatchToBetParlay: "อย่างน้อยผสมการแข่งขันสองนัดเพื่อเดิมพันในพาร์เลย์",
  atLeastThreeMatchToBetParlay: "อย่างน้อยผสมสามนัดเพื่อเดิมพันในพาร์เลย์",
  duplicate_debit_record: "อัตราเดิมพันกำลังอัปเดต...",

  insufficient_balance: "เครดิตไม่เพียงพอ",
  betOverMaxPerMatch: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด.",
  betOverMax: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betOverMaxBet: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  betLowerMin: "เงินเดิมพันของคุณน้อยกว่าเงินเดิมพันขั้นต่ำ",

  loginFailed: "เงินเดิมพันของคุณเกินเงินเดิมพันสูงสุด",
  requestFailed: "การเชื่อมต่อของคุณไม่เสถียร โปรดตรวจสอบการเชื่อมต่อแล้วลองอีกครั้ง",
  requestPending: "รอการร้องขอ …",

  close: "บัญชีถูกปิด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  suspend: "บัญชีถูกระงับ! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",
  freeze: "บัญชีถูกอายัด! โปรดติดต่อทีมงานอัพไลน์ของคุณเพื่อดำเนินการต่อ ...",

  alphaNumOnly: "ตัวอักษรและตัวเลขเท่านั้น",

  // vuelidate
  isRequired: "โปรดป้อน {fname}.",
  isMinValue: "{fname} ต้องมีอย่างน้อย {fvalue}.",
  isMaxValue: "{fname} ต้องน้อยกว่าหรือเท่ากับ {fvalue}.",
  isMinLength: "{fname} ต้องมีอักขระอย่างน้อย {fvalue} ตัว.",
  isMaxLength: "{fname} ต้องน้อยกว่าหรือเท่ากับอักขระ {fvalue} ตัว.",
  isAlpha: "{fname} ยอมรับเฉพาะตัวอักษรเท่านั้น.",
  isAlphaNum: "{fname} ยอมรับเฉพาะตัวอักษรและตัวเลข.",
  isNumeric: "{fname} ยอมรับเฉพาะตัวเลข.",
  isEmail: "{fname} ยอมรับที่อยู่อีเมลที่ถูกต้องเท่านั้น.",
  isIpAddress: "{fname} ยอมรับเฉพาะที่อยู่ IPv4 ที่ถูกต้อง",
  isSameAs: "{fname} ต้องเหมือนกับ {fname2}.",
  isUrl: "{fname} ยอมรับ URL เท่านั้น",
  containAlphaNum: "{fname} ต้องมีตัวอักษรอย่างน้อยหนึ่งตัวและหนึ่งหมายเลข",
  selectOption: "กรุณาเลือก {fname}",
  notSameAs: "{fname} และ {fname2} ต้องไม่เหมือนกัน",

  currPasswordRequired: "ต้องใช้รหัสผ่านปัจจุบัน!",
  newPasswordRequired: "ต้องการรหัสผ่านใหม่!",
  confirmNewPasswordRequired: "ยืนยันว่าต้องการรหัสผ่านใหม่!",
  passwordsNotMatch: "รหัสผ่านไม่ตรงกัน!",
  nickNameRequired: "ต้องมีชื่อเล่น!",

  startDateRequired: "ต้องระบุวันที่เริ่ม!",
  endDateRequired: "ต้องระบุวันที่สิ้นสุด!",
  pageSizeRequired: "ต้องระบุขนาดหน้าเพจ!",
  pageNumberRequired: "ต้องระบุหมายเลขหน้าเพจ!",
  sportsTypeRequired: "ต้องมีประเภทกีฬา!",

  workingDateRequired: "ต้องระบุวันทำงาน!",
  leagueIdRequired: "ต้องระบุลีก ID!",
  isOutrightRequired: "จำเป็นต้องขอข้อมูล",

  maxParlayTicket: "เข้าถึงตั๋วสูงสุดต่อพาร์เลย์!",
  matchHide: "แมตช์นี้ไม่พร้อมใช้งาน โปรดลองแมตช์อื่น",
  matchNotAllowBet: "แมตช์นี้ไม่พร้อมใช้งาน โปรดลองแมตช์ในตลาดอื่น",
  matchNotActive: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",
  invalidBets: "ตลาดนี้ไม่พร้อมใช้งานโปรดลองตลาดอื่น",

  invalidOddsBall: "อัตราเดินพันกำลังอัปเดต ...",
  selectLeague: "โปรดเลือกอย่างน้อย 1 ลีก",
  liveCasinoDisabled: "ปิดการใช้งานคาสิโนสด",
  slotDisabled: "ปิดการใช้งานสล็อต",
  lotteryDisabled: "ปิดการใช้งานลอตเตอรี่",
  MiniGameDisabled: "ปิดการใช้งานมินิเกม",
  EsportsDisabled: "เกม E-Sports ปิดการใช้งาน",
  currencyNotSupported: "ไม่รองรับสกุลเงิน",
  game_maintenance: "เกมกำลังปิดปรับปรุง",
  forbiddenAccess: "ไม่ได้รับอนุญาตการเข้าถึง",
  invalidCurrency: "สกุลเงินที่จะเดิมพันไม่ถูกต้อง",
  connectionFailed: "ไม่สามารถเชื่อมไปยังระบบกระเป๋าเงินได้",

  //tournament
  login_id_not_exists: "การเข้าสู่ระบบไม่ถูกต้อง โปรดลองเข้าสู่ระบบอีกครั้ง",
  noMatchSelected: "โปรดเลือกอย่างน้อย 1 รายการ",
  invalidRoomRate: "ราคาห้องพักไม่ถูกต้อง",
  invalidRoomLimit: "การจำกัดห้องไม่ถูกต้อง",
  invalidRoomPassword: "รหัส PIN ไม่ถูกต้อง รหัส PIN ต้องเป็นตัวเลข 6 หลัก",
  invalidPassword: "รหัสผ่านไม่ถูกต้อง",
  roomPasswordRequired: "ต้องใช้รหัส PIN",
  minMatch: "เลือกการแข่งขันขั้นต่ำ 3 รายการ",
  maxMatch: "เลือกได้สูงสุด {max} รายการ",
  roomIdRequired: "ต้องมีรหัสห้อง",
  roomTypeRequired: "จำเป็นต้องระบุประเภทห้อง",
  sessionTokenRequired: "จำเป็นต้องมีโทเค็นเซสชั่น",
  matchDateRequired: "ต้องมีวันที่ตรงกัน",
  matchRequired: "ต้องมีการจับคู่",
  roomLimitRequired: "ต้องจำกัดจำนวนห้อง",
  roomRateRequired: "ต้องระบุราคาห้องพัก",
  minRoomRate: "ค่าธรรมเนียมแรกเข้าต้องเท่ากับหรือมากกว่า 10",
  maxRoomRate: "ค่าธรรมเนียมแรกเข้าต้องเท่ากับหรือน้อยกว่า 1,000",
  minRoomLimit: "จำนวนผู้เล่นต้องเท่ากันหรือมากกว่า 3",
  maxRoomLimit: "จำนวนผู้เล่นต้องเท่ากับหรือน้อยกว่า 30",
  invalidRoomType: "ประเภทห้องไม่ถูกต้อง",
  invalidMatch: "การจับคู่ไม่ถูกต้อง",
  dataError: "ข้อมูลผิดพลาด",
  memberExists: "มีสมาชิกอยู่แล้ว",
  invalidMember: "สมาชิกไม่ถูกต้อง",
  invalidleague: "ลีกไม่ถูกต้อง",
  "createRoomFailed-1": "สร้างห้องล้มเหลว 1",
  "createRoomFailed-2": "สร้างห้องล้มเหลว 2",
  "createRoomFailed-3": "สร้างห้องล้มเหลว 3",
  invalidOperator: "ตัวดำเนินการไม่ถูกต้อง",
  roomFull: "ห้องเต็มแล้ว",
  memberExists: "สมาชิกมีอยู่แล้ว",
  "joinFailed-1": "เข้าร่วมห้องล้มเหลว 1",
  "joinFailed-2": "เข้าร่วมห้องล้มเหลว 2",
  IPJoinedBefore: "IP เข้าร่วมก่อน",
  memberJoinedBefore: "คุณเคยเข้าร่วมมาก่อน โปรดทราบว่าห้องสาธารณะฟรีสามารถเข้าร่วมได้เพียงครั้งเดียว",
  roomNotExists: "ไม่มีห้องอยู่",
  roomIsPublicFree: "ห้องสาธารณะฟรี",
  roomEndedOrCancelled: "ห้องสิ้นสุดหรือถูกยกเลิก",
  roomEnded: "ห้องสิ้นสุดแล้ว",

  matchLowerMin: "เกิดข้อผิดพลาดในการจับคู่ค่าต่ำสุด",
  matchOverMax: "เกิดข้อผิดพลาด Match over max",
  pointOverLimit: "เกิดข้อผิดพลาดของ point over limit",
  roomOverMax: "เกิดข้อผิดพลาด Room Over Max",
  invalidRoom: "ห้องไม่ถูกต้อง",
  roomLimitOverMax: "เกิดข้อผิดพลาดเกินขีดจำกัดของห้อง",
  rateLowerMin: "เกิดข้อผิดพลาดขั้นต่ำของอัตราที่ต่ำกว่า",
  rateOverMax: "เกิดข้อผิดพลาดอัตราเกินสูงสุด",

  liveMatchNotAllowed: "ไม่อนุญาตให้มีการแข่งขันสด",
  roomLimitLowerMin: "เกิดข้อผิดพลาดต่ำสุดของขีดจำกัดห้อง",
  roomClosed: "ห้องปิด",
  tournamentLeagueExists: "มีลีกทัวร์นาเมนต์อยู่",
  roomExists: "ไม่อนุญาตให้สร้างห้องส่วนตัวมากกว่า 1 ห้อง",
  roomExists: "ไม่อนุญาตให้สร้างห้องส่วนตัวมากกว่า 1 ห้อง",
  betExists: "มีการเดิมพันอยู่แล้ว",
  roomClosedNotAllowed: "ไม่อนุญาตให้ปิดห้อง",
  tournamentMatchExists: "มีการแข่งขันทัวร์นาเมนต์",
  account_id_required: "จำเป็นต้องมี ID บัญชี",
  agent_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นตัวแทน",
  agent_id_required: "ต้องมีรหัสตัวแทน",
  bet_amount_required: "ต้องมีจำนวนเงินเดิมพัน",
  bet_id_required: "ต้องมี ID เดิมพัน",
  credit_amount_required: "จำเป็นต้องมีจำนวนเครดิต",
  currency_required: "ต้องใช้สกุลเงิน",
  debit_amount_required: "ต้องระบุจำนวนเดบิต",
  duplicate_credit_record: "บันทึกเครดิตซ้ำ",
  master_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นหลัก",
  master_id_required: "ต้องมี Master ID",
  member_id_required: "ต้องมีรหัสสมาชิก",
  member_wallet_not_exists: "ไม่มีกระเป๋าเงินสมาชิก",
  permission_denied: "การอนุญาตถูกปฏิเสธ",
  rate_required: "จำเป็นต้องระบุราคา",
  result_exists: "ผลลัพธ์มีอยู่แล้ว",
  room_id_required: "ต้องมีรหัสห้อง",
  s_senior_comm_rate_required: "จำเป็นต้องมีอัตราค่าคอมมิชชั่น Super Senior",
  s_senior_id_required: "จำเป็นต้องมี Super Senior ID",
  senior_comm_rate_required: "ต้องมีอัตราค่าคอมมิชชั่นอาวุโส",
  senior_id_required: "ต้องมี ID อาวุโส",
  shareholder_comm_rate_required: "ต้องระบุอัตราค่าคอมมิชชั่นสำหรับผู้ถือหุ้น",
  shareholder_id_required: "ต้องมีรหัสผู้ถือหุ้น",
  transfer_id_required: "ต้องมี ID การโอน",
  minBetAmount: "เกิดข้อผิดพลาดจำนวนเงินเดิมพันขั้นต่ำ",
  tournamentDisabled: "การแข่งขันถูกปิดใช้งาน โปรดตรวจสอบติดต่ออัพไลน์ของคุณ",
  // tournamentDisabled: "การแข่งขันเร็ว ๆ นี้ โปรดติดตาม!",
  marketTypeRequired: "ต้องระบุประเภทตลาด",
  invalidMarketType: "ระบุประเภทตลาดไม่ถูกต้อง",
  marketTypeChanged: "ใบเดิมพัน ถูกลบออกเนื่องจากมีการเปลี่ยนแปลงประเภทตลาด <br/> โปรดเลือกใหม่จากตลาดอีกครั้ง.",
  changeStakeMin: "จำนวนเงินเดิมพันเข้ามีการเปลี่ยนแปลงเนื่องจากขีดจำกัดขั้นต่ำ",
  changeStakeMax: "จำนวนเงินเดิมพันเข้ามีการเปลี่ยนแปลงเนื่องจากขีดจำกัด MAX",
  betNotExists: "กรุณาวางเดิมพันที่ถูกต้องเพื่อเข้าร่วมการแข่งขัน.",
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
